/** 파일배열을 멀티파트폼으로 변환 */
const files2data = (files, key = 'files') => {
  const formData = new FormData();
  formData.headers = { 'Content-Type': 'multipart/form-data' };
  for (const f of files) formData.append(key, f.blob || f, f.name);
  return formData;
};

/** 이미지 로딩 Promise */
const loadImg = src => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

const canvas2transparent = (canvas, bound, trans) => { // th: 0 ~ 765 클수록 선명하지만 노이즈
  var ctx = canvas.getContext('2d'), w = canvas.width, h = canvas.height;
  var imageData = ctx.getImageData(0, 0, w, h);
  for (var x = 0; x < imageData.width; x++)
    for (var y = 0; y < imageData.height; y++) {
      var offset = (y * imageData.width + x) * 4;
      var r = imageData.data[offset];
      var g = imageData.data[offset + 1];
      var b = imageData.data[offset + 2];
      //if it is pure white, change its alpha to 0              
      // if (r < g + b || r + g + b > bound)
      if (r + g + b > bound)
        imageData.data[offset + 3] = 255 - (r + g + b) * 100 / trans;
    }
  ctx.putImageData(imageData, 0, 0);
}

export { files2data, loadImg, canvas2transparent };